// extracted by mini-css-extract-plugin
module.exports = {"avatar":"e_Cy","fallback":"e_Dy","s40":"e_Ey","s32":"e_Fy"};